import { useState, useEffect, useCallback } from 'react';
import ApiService from '../services/api';

export const useUnavailableDates = (userId) => {
  const [unavailableDates, setUnavailableDates] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUnavailableDates = useCallback(async () => {
    if (!userId) return;
    setIsLoading(true);
    setError(null);
    try {
      const data = await ApiService.get(`unavailable-dates/user/${userId}`);
      setUnavailableDates(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message || 'Failed to load unavailable dates.');
    } finally {
      setIsLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    fetchUnavailableDates();
  }, [fetchUnavailableDates]);

  const addUnavailableRange = useCallback(async (startDate, endDate) => {
    setError(null);
    try {
      await ApiService.post('unavailable-dates', {
        start_date: startDate,
        end_date: endDate,
      });
      await fetchUnavailableDates();
    } catch (err) {
      setError(err.message || 'Failed to save unavailable date range.');
      throw err;
    }
  }, [fetchUnavailableDates]);

  const removeUnavailableRange = useCallback(async (id) => {
    setError(null);
    try {
      await ApiService.delete(`unavailable-dates/${id}`);
      await fetchUnavailableDates();
    } catch (err) {
      setError(err.message || 'Failed to remove unavailable date range.');
      throw err;
    }
  }, [fetchUnavailableDates]);

  return {
    unavailableDates,
    isLoading,
    error,
    addUnavailableRange,
    removeUnavailableRange,
    refetch: fetchUnavailableDates,
  };
};
